import { Link } from "@/lib/router-compat";

const SiteHeader = () => {
  return (
    <header className="bg-[#f6f7f9] border-b border-gray-300">
      <div className="max-w-2xl lg:max-w-3xl mx-auto">
        {/* Main Header */}
        <div className="bg-gradient-to-r from-[#4267B2] to-[#5b7bd5] px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
            </svg>
            <div>
              <span className="text-white font-bold text-lg md:text-xl block">Central de Saúde Masculina</span>
              <p className="text-white/80 text-xs md:text-sm">Guias especializados • Informação confiável • Respostas reais</p>
            </div>
          </Link>
          {/* Bandeira do Brasil */}
          <div className="shrink-0">
            <svg className="w-10 h-7 md:w-12 md:h-8 rounded shadow-xs" viewBox="0 0 60 40" aria-label="Bandeira do Brasil">
              <rect width="60" height="40" fill="#009C3B"/>
              <polygon points="30,5 55,20 30,35 5,20" fill="#FFDF00"/>
              <circle cx="30" cy="20" r="7" fill="#002776"/>
            </svg>
          </div>
        </div>

        {/* Navigation */}
        <nav className="px-4 py-3 bg-white border-b border-gray-200 flex items-center gap-4 text-sm overflow-x-auto">
          <Link to="/" className="text-[#385898] font-semibold whitespace-nowrap hover:underline">🏠 Início</Link>
          <Link to="/artigos" className="text-gray-600 whitespace-nowrap hover:text-[#385898]">📚 Artigos</Link>
          <Link to="/guias/pequenas-bolinhas-no-penis" className="text-gray-600 whitespace-nowrap hover:text-[#385898]">📖 Guia Completo</Link>
          <Link to="/perguntas-frequentes" className="text-gray-600 whitespace-nowrap hover:text-[#385898]">❓ Perguntas Frequentes</Link>
          <Link to="/blog" className="text-gray-600 whitespace-nowrap hover:text-[#385898]">✍️ Blog</Link>
          <Link to="/processo-editorial" className="text-gray-600 whitespace-nowrap hover:text-[#385898]">🏛️ Editorial</Link>
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;